/* BRINUTI – a választott szalagszín a Teeinblue-galéria élő mockupjain
   (2026-10-16, a tulaj kérése).

   A galéria első három képe (nyilas előlap, előlap, hátlap) a böngészőben
   rétegekből áll össze: alul egy közös alapkép (üres fehér napló, fekete
   könyvjelzőszalagokkal), fölötte a vevő borítóterve. Mind a 129 napló
   ugyanazt a két alapképet használja (előlap: 6a0c0ade6530a, hátlap:
   6a0c0fd567011). Szalagváltáskor CSAK ezt az alapképet cseréljük a
   választott színű változatára (assets/bsm-<szín>--<alapkép>_large.webp) —
   a borítóréteghez nem nyúlunk, így minden borítón működik.

   A Teeinblue a galériát időnként újrarajzolja (szín-, mintaváltás,
   szerkesztőablak), ezért egy MutationObserver minden új alapképet újra
   átállít. Az eredeti címet a data-bsm-eredeti őrzi: a pillanatkép
   (brinuti-cro.js) ezt menti el, a szalagszínt pedig mindig a kosársor
   adja hozzá kirajzoláskor (lent).

   A fekete szalag az eredeti kép. A 4–7. kép kész fotó, azokon nincs csere.

   2026-10-16 (2. kör): a kosár kis képén, a kosár-előnézetben, a levélképen
   (_brinuti_elonezet) és az abból készülő pénztárképen (_brinuti_kep) is a
   sor szalagszíne látszik; ha a vevő az előnézetben szalagot vált, a levél-
   és a pénztárkép újra elkészül (brinuti-cro.js). A pénztár alsó kis képe a
   termék általános képe — azt a Shopify nem engedi vevőnként cserélni. */
(function () {
  var ALAPOK = ['6a0c0ade6530a', '6a0c0fd567011'];
  var SZINEK = { kek: 1, szurke: 1, barna: 1, piros: 1, bezs: 1, rozsaszin: 1 };
  var szkript = document.currentScript;
  var mappa = szkript ? szkript.src.split('?')[0].replace(/[^/]*$/, '') : '';
  if (!mappa) return;

  function slug(szoveg) {
    return String(szoveg || '').toLowerCase().trim()
      .normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z]/g, '');
  }

  // A szalag mező egy űrlapon belül: a fejlécében szerepel a „szalag” szó.
  function szalagSzine(gyoker) {
    if (!gyoker) return null;
    var sajat = gyoker.querySelector('.btv-szal[aria-checked="true"]');
    if (sajat) return slug(sajat.getAttribute('title'));
    var mezok = gyoker.querySelectorAll('.tee-field');
    for (var i = 0; i < mezok.length; i++) {
      var fej = mezok[i].querySelector('.tee-field__heading, .tee-field__label, label');
      if (!fej || !/szalag/i.test(fej.textContent)) continue;
      var sel = mezok[i].querySelector('select');
      if (sel && sel.selectedIndex >= 0 && sel.value) return slug(sel.options[sel.selectedIndex].text);
      var be = mezok[i].querySelector('input[type="radio"]:checked');
      if (be) {
        var cimke = be.id && window.CSS && CSS.escape ? mezok[i].querySelector('label[for="' + CSS.escape(be.id) + '"]') : null;
        if (!cimke) {
          var elem = be.closest('.tee-radio-field__item');
          cimke = elem && elem.querySelector('label');
        }
        return slug(cimke ? cimke.textContent : be.value);
      }
    }
    return null;
  }

  // Melyik űrlap tartozik a képhez? A kosárból nyitott szerkesztőablak
  // képeihez az ablak űrlapja, minden máshoz (termékoldal, Előnézet
  // ablak) a termékoldalé.
  function urlapA(kep) {
    var ablak = kep.closest('.tee-edit-popup');
    if (ablak) return ablak;
    return document.getElementById('tee-artwork-form') || document.getElementById('teeFormInputs') ||
      document.querySelector('.tee-edit-popup');
  }

  function alapja(cim) {
    for (var i = 0; i < ALAPOK.length; i++) if (cim.indexOf(ALAPOK[i]) >= 0) return ALAPOK[i];
    return null;
  }

  var elotoltve = {};
  function elotolt(szin) {
    if (!SZINEK[szin] || elotoltve[szin]) return;
    elotoltve[szin] = true;
    ALAPOK.forEach(function (a) { new Image().src = cime(a, szin); });
  }

  // A téma verziószámos címeit használjuk (layout/theme.liquid): a verzió
  // nélküli címre a CDN képcsere után is a régi képet adta.
  function cime(alap, szin) {
    if (!SZINEK[szin]) return '';
    var tar = window.brinutiSzalagKepek || {};
    return tar[szin + '--' + alap] || (mappa + 'bsm-' + szin + '--' + alap + '_large.webp');
  }

  // Egy kép alapját a megadott színű szalagosra állítja (üres / fekete szín:
  // vissza az eredetire). Az eredeti címet a data-bsm-eredeti őrzi.
  function szinezd(kep, szin) {
    var eredeti = kep.getAttribute('data-bsm-eredeti') || kep.getAttribute('src') || '';
    var alap = alapja(eredeti);
    if (!alap || eredeti.indexOf('bsm-') >= 0) return;
    var cel = cime(alap, szin) || eredeti;
    if (cel === eredeti) {
      if (kep.hasAttribute('data-bsm-eredeti')) {
        kep.removeAttribute('data-bsm-eredeti');
        kep.setAttribute('src', eredeti);
      }
      return;
    }
    if (!kep.hasAttribute('data-bsm-eredeti')) kep.setAttribute('data-bsm-eredeti', eredeti);
    // A Teeinblue crossorigin-nal tölti a rétegeket; a mi képünk a bolt saját
    // CDN-jén van (CORS: *), ugyanígy betölthető és vászonra rajzolható.
    if (kep.getAttribute('src') !== cel) kep.setAttribute('src', cel);
    elotolt(szin);
  }

  function allit() {
    // 1. A Teeinblue saját galériája (termékoldal, Előnézet, szerkesztőablak):
    //    a szín az űrlapról jön.
    var kepek = document.querySelectorAll('.tee-slide img');
    for (var i = 0; i < kepek.length; i++) szinezd(kepek[i], szalagSzine(urlapA(kepek[i])));
    // 2. A mentett tervből kirajzolt képek (kosár kis képe, kosár-előnézet):
    //    a szín a kosársorból (data-brinuti-szalag, lásd cart-products.liquid és
    //    brinuti-cro.js). A pillanatkép-másolat (.tee-mockup, keret nélkül)
    //    érintetlen marad.
    var keretek = document.querySelectorAll('[data-brinuti-szalag]');
    for (var k = 0; k < keretek.length; k++) {
      var szin = slug(keretek[k].getAttribute('data-brinuti-szalag'));
      var benne = keretek[k].querySelectorAll('img');
      for (var n = 0; n < benne.length; n++) szinezd(benne[n], szin);
    }
  }

  // A levélkép rajzolója (brinuti-cro.js) is ezt használja.
  // Egy mentett terv HTML-jében az alapkép címét a színesre írja (a levélkép
  // rajzolója a képeket a HTML-ből tölti be — így biztosan a színeset kapja).
  function htmlbe(html, szoveg) {
    var szin = slug(szoveg);
    if (!SZINEK[szin] || !html) return html;
    return String(html).replace(/(["'])[^"']*?(6a0c0ade6530a|6a0c0fd567011)_large\.webp[^"']*\1/g, function (egesz, idezo, alap) {
      return idezo + cime(alap, szin) + idezo;
    });
  }

  window.brinutiSzalag = { slug: slug, szinezd: szinezd, htmlbe: htmlbe };

  var utemezve = false;
  function utemez() {
    if (utemezve) return;
    utemezve = true;
    (window.requestAnimationFrame || setTimeout)(function () { utemezve = false; allit(); });
  }

  new MutationObserver(function (valtozasok) {
    for (var i = 0; i < valtozasok.length; i++) {
      var v = valtozasok[i];
      if (v.type === 'attributes') {
        if (v.attributeName !== 'src' || v.target.tagName === 'IMG') { utemez(); return; }
      } else if (v.addedNodes.length) { utemez(); return; }
    }
  }).observe(document.documentElement, {
    childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'aria-checked', 'data-brinuti-szalag']
  });
  document.addEventListener('change', utemez, true);
  document.addEventListener('click', function () { setTimeout(utemez, 50); }, true);
  utemez();
})();
